import { render, staticRenderFns } from "./trends.vue?vue&type=template&id=44234c5c&scoped=true"
import script from "./trends.vue?vue&type=script&lang=js"
export * from "./trends.vue?vue&type=script&lang=js"
import style0 from "./trends.vue?vue&type=style&index=0&id=44234c5c&prod&scoped=true&lang=css"
import style1 from "./trends.vue?vue&type=style&index=1&id=44234c5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44234c5c",
  null
  
)

export default component.exports